import { render, staticRenderFns } from "./func-add.vue?vue&type=template&id=40f60dcc&scoped=true"
import script from "./func-add.vue?vue&type=script&lang=js"
export * from "./func-add.vue?vue&type=script&lang=js"
import style0 from "./func-add.vue?vue&type=style&index=0&id=40f60dcc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f60dcc",
  null
  
)

export default component.exports